function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;

    if (image.complete) {
      resolve(1);
    } else {
      const handleLoad = () => {
        image.removeEventListener("load", handleLoad);
        resolve(1);
      };
      image.addEventListener("load", handleLoad);
    }
  });
}

function loadVideoOrAudio(src, type) {
  return new Promise((resolve, reject) => {
    const video = document.createElement(type);
    video.muted = true;
    video.preload = true;
    video.src = src;

    const handleCanplaythrough = () => {
      video.removeEventListener("canplaythrough", handleCanplaythrough);
      resolve(1);
    };
    video.addEventListener("canplaythrough", handleCanplaythrough);
  });
}

interface IAsset {
  // default image
  type: "video" | "audio" | "image" | string;
  src: string;
}

export function preload(assets: IAsset[]) {
  // console.log("preload", { assets });
  return new Promise(async (resolve, reject) => {
    const promises = assets.map((asset) =>
      ["video", "audio"].includes(asset.type)
        ? loadVideoOrAudio(asset.src, asset.type)
        : loadImage(asset.src)
    );
    resolve(await Promise.all(promises));
  });
}

export function preloadEx({
  assets,
  onProgress,
}: {
  assets: IAsset[];
  onProgress?(progress): void;
}) {
  const total = assets.length;
  let completed = 0;

  assets.forEach(async (asset) => {
    if (["video", "audio"].includes(asset.type)) {
      await loadVideoOrAudio(asset.src, asset.type);
      completed++;
    } else {
      await loadImage(asset.src);
      completed++;
    }

    onProgress?.(completed / total);
  });
}
